import React from 'react';
import ClinicSettingsCancelButton from './ClinicSettingsCancelButton';

function ClinicSettingsFormFooter({ isSaving = false, submitLabel = 'Save Changes', showCancel = false, onCancel }) {
    return (
        <div className="clinic-info-form__footer clinic-settings-form-footer">
            {showCancel && (
                <ClinicSettingsCancelButton onClick={onCancel} disabled={isSaving} />
            )}
            <button
                type="submit"
                className="btn btn-sm btn-light-primary rounded-pill px-4"
                disabled={isSaving}
            >
                <i className={`bi ${isSaving ? 'bi-arrow-clockwise ecx-refresh-spin' : 'bi-check-lg'} me-1`}></i>
                {isSaving ? 'Saving...' : submitLabel}
            </button>
        </div>
    );
}

export default ClinicSettingsFormFooter;
